import { useState } from "react";
import { Package } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

// Image with graceful fallback to a package icon when the URL is missing/broken.
// When `zoomable` and a valid src exist, clicking opens a large lightbox preview.
export function BomImage({ src, alt, className = "h-10 w-10", zoomable = false }) {
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(false);

  if (!src || !String(src).trim() || failed) {
    return (
      <span className={`${className} rounded-md bg-slate-100 flex items-center justify-center text-slate-400 shrink-0`}>
        <Package className="h-1/2 w-1/2" />
      </span>
    );
  }

  const img = (
    <img
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      onClick={zoomable ? () => setOpen(true) : undefined}
      className={`${className} rounded-md object-cover shrink-0 ${zoomable ? "cursor-zoom-in hover:opacity-90 transition-opacity" : ""}`}
      data-testid={zoomable ? "bom-image-zoom-trigger" : undefined}
    />
  );

  if (!zoomable) return img;

  return (
    <>
      {img}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl p-2 bg-black/90 border-0" data-testid="bom-image-lightbox">
          <img src={src} alt={alt} className="w-full max-h-[80vh] object-contain rounded-md" />
          {alt && <p className="text-center text-xs text-slate-200 pt-1 pb-0.5">{alt}</p>}
        </DialogContent>
      </Dialog>
    </>
  );
}
